export enum FlowType {
  EXISTING = 'existing',
  NEW = 'new',
}
